import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';
import { MaterialModule } from './material.module';
import { FormsModule } from '@angular/forms';
import { LayoutModule } from '@angular/cdk/layout';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { OverlayModule } from '@angular/cdk/overlay';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './content/pages/header/header.component';
import { SidenavComponent } from './content/pages/sidenav/sidenav.component';
import { MenuItemComponent } from './content/pages/menu-item/menu-item.component';

import { MainComponent } from './content/pages/main/main.component';
import { WebAgoraWebButtonComponent } from './content/pages/conexion/web-agoraweb-button/web-agoraweb-button.component';
import { WebAgoraWebFormButtonComponent } from './content/pages/conexion/web-agoraweb-form-button/web-agoraweb-form-button.component';
import { WebAgoraWebNoFormButtonComponent } from './content/pages/conexion/web-agoraweb-noform-button/web-agoraweb-noform-button.component';
import { WebCardsButtonComponent } from './content/pages/conexion/web-cards-button/web-cards-button.component';

import { NgGistModule } from 'ng-gist';
import { ApiOperationsComponent } from './content/pages/api/api-operations/api-operations.component';
import { ApiEventsComponent } from './content/pages/api/api-events/api-events.component';
import { ApiOrdersComponent } from './content/pages/api/api-orders/api-orders.component'
import { FlutterCardsButtonComponent } from './content/pages/conexion/flutter-cards-button/flutter-cards-button.component';
import { FlutterAgorawebButtonComponent } from './content/pages/conexion/flutter-agoraweb-button/flutter-agoraweb-button.component';
import { FlutterAgoraWebFormButtonComponent } from './content/pages/conexion/flutter-agoraweb-form-button/flutter-agoraweb-form-button.component';
import { FlutterAgoraWebNoformButtonComponent } from './content/pages/conexion/flutter-agoraweb-noform-button/flutter-agoraweb-noform-button.component';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SidenavComponent,
    MenuItemComponent,

    MainComponent,
    WebAgoraWebButtonComponent,
    WebAgoraWebFormButtonComponent,
    WebAgoraWebNoFormButtonComponent,
    WebCardsButtonComponent,
    FlutterAgorawebButtonComponent,
    FlutterAgoraWebFormButtonComponent,
    FlutterAgoraWebNoformButtonComponent,
    FlutterCardsButtonComponent,
    ApiOperationsComponent,
    ApiEventsComponent,
    ApiOrdersComponent,

  ],
  imports: [
    BrowserModule,
    AppRoutingModule,
    MaterialModule,
    BrowserAnimationsModule,
    FormsModule,
    LayoutModule,
    OverlayModule,
    NgGistModule
  ],
  providers: [],
  bootstrap: [AppComponent],
  entryComponents: [
  ]
})
export class AppModule { }
